export function handleInsuranceFancy() {
  const buttonEls = document.querySelectorAll('.js-insurance-open-fancy')

  if (!buttonEls.length) return

  buttonEls.forEach(buttonEl => {
    const fancyEl = document.querySelector(buttonEl.dataset.src)

    buttonEl.addEventListener('click', () => {
      fancyEl.querySelector('input[name="source"]').value = buttonEl.dataset.formName
      fancyEl.querySelector('button[type="submit"]').textContent = buttonEl.dataset.formName

      $.fancybox.open({
        src: buttonEl.dataset.src
      })
    })
  })
}
